import sanitizeHtml from 'sanitize-html';
import _ from 'lodash';
import _get from 'lodash/get';
export const sanitizeOpts = {
  allowedTags: ['br'],
  allowedAttributes: {},
};

export const downloadFromBlob = (response, fileName) => {
  const element = document.createElement('a');
  element.href = window.URL.createObjectURL(new Blob([response.data]));
  element.target = '_blank';

  if (response.headers['content-disposition']) {
    const contentDisposition = response.headers['content-disposition'];
    const parts = contentDisposition.split(';').map((part) => part.trim());

    // Get the last part
    const lastPart = parts[parts.length - 1];

    // Split the last part on equal sign to get the key and value
    const [key, value] = lastPart.split('=').map((part) => part.trim());

    let filename = value;
    if (filename.startsWith('"') && filename.endsWith('"')) {
      filename = filename.substring(1, filename.length - 1);
    }

    // If it's an extended filename, decode it
    if (key === 'filename*') {
      filename = decodeURI(filename.replace('UTF-8\'\'', ''));
    }
    element.setAttribute(
      'download',
      filename,
    );
  } else {
    element.setAttribute('download', fileName);
  }
  document.body.appendChild(element);
  element.click();
};

export const downloadFileByUrlV2 = async(url, fileName, httpClient) => {
  try {
    const response = await httpClient({
      url,
      method: 'GET',
      responseType: 'blob',
    });
    downloadFromBlob(response, fileName);
  } catch (e) {
    throw e;
  }
};

export const deepDiff = (original, toCompare) => {
  return _.transform(original, function(result, value, key) {
    if (!_.isEqual(value, toCompare[key])) {
      if (_.isObject(value) && _.isObject(toCompare[key]) && !_.isArray(value)) {
        result[key] = deepDiff(value, toCompare[key]);
      } else {
        result[key] = toCompare[key];
      }
    }
  });
};

export const removeAllLocalStorage = () => {
  localStorage.removeItem('itrack_core_timezones');
  localStorage.removeItem('itrack_core_countries');
  localStorage.removeItem('quest_positions');

  localStorage.removeItem('itrack_notifs_filters');

  localStorage.removeItem('itrack_forward_to_foreigner');
  localStorage.removeItem('itrack_forward_to_messaging');
  localStorage.removeItem('itrack_forward_to_questionnaires');

  localStorage.removeItem('itrack_for_forward_to_q');
  localStorage.removeItem('itrack_for_forward_to_permit');
  localStorage.removeItem('itrack_for_forward_to_permit_document');
  localStorage.removeItem('itrack_for_forward_to_messaging');

  localStorage.removeItem('itrack_adm_forward_to_foreigner');
  localStorage.removeItem('itrack_adm_forward_to_foreigner_permit');
  localStorage.removeItem('itrack_adm_forward_to_foreigner_permit_documents');
  localStorage.removeItem('itrack_adm_forward_to_foreigner_messaging');
  localStorage.removeItem('itrack_adm_forward_to_foreigner_questionnaires');

  localStorage.removeItem('itrack_forward_to_me');

  localStorage.removeItem('itrack_flagPermit');
  localStorage.removeItem('itrack_flagDocument');

  for (const el of Object.keys(localStorage).filter((el) => el.includes('itrack_msg'))) {
    localStorage.removeItem(el);
  }
};

export const removeLocalStorageFiltersRpp = () => {
  localStorage.removeItem('itrack_foreigner_filters');
  localStorage.removeItem('itrack_foreigner_data');
  localStorage.removeItem('itrack_rpp_admin_fors');
  localStorage.removeItem('itrack_foreigners_data');

  localStorage.removeItem('itrack_notifs_filters');

  localStorage.removeItem('itrack_refresh_admin_agency_comp');
  localStorage.removeItem('itrack_refresh_admin_agency_user');
  localStorage.removeItem('itrack_refresh_admin_cli_comp');
  localStorage.removeItem('itrack_refresh_admin_cli_user');
  localStorage.removeItem('itrack_refresh_admin_int_user');
  localStorage.removeItem('itrack_refresh_admin_int_places');
  localStorage.removeItem('itrack_refresh_admin_perm_types');
  localStorage.removeItem('itrack_refresh_admin_perm_doc');
  localStorage.removeItem('itrack_refresh_admin_perm_date');
  localStorage.removeItem('itrack_refresh_admin_perm_stat');
  localStorage.removeItem('itrack_refresh_admin_perm_types');
};

export const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
    if ((encoded.length % 4) > 0) {
      encoded += '='.repeat(4 - (encoded.length % 4));
    }
    resolve(encoded);
  };
  reader.onerror = (error) => reject(error);
});

const formatErrors = (field, errors) => {
  let formattedErrors = '';

  if (typeof errors === 'string') {
    formattedErrors += `${field.capitalize()}: ${errors}<br/>`;
  } else if (Array.isArray(errors)) {
    errors.forEach((errorMessage) => {
      formattedErrors += formatErrors(field, errorMessage);
    });
  } else if (typeof errors === 'object') {
    for (const subField in errors) {
      if (errors.hasOwnProperty(subField)) {
        formattedErrors += formatErrors(`${field}.${subField}`, errors[subField]);
      }
    }
  }

  return formattedErrors;
};

export const getValidationError = (error) => {
  const data = _get(error, 'response.data.data');
  let allErrors = '';

  if (data) {
    for (const field in data) {
      if (data.hasOwnProperty(field)) {
        allErrors += formatErrors(field, data[field]);
      }
    }
  } else {
    const message = _get(error, 'response.data.message');
    allErrors = (message || 'Error').capitalize();
  }

  return allErrors;
};

export default {
  sanitizeHtml,
  sanitizeOpts,
  downloadFromBlob,
  removeAllLocalStorage,
  removeLocalStorageFiltersRpp,
  fileToBase64,
};
